import type { IconName } from "../ui/Icon";

/**
 * Picker choices for the CategoryFormDialog. Curated rather than
 * derived from the full Icon library so each icon makes sense as a
 * spending-category glyph — generic objects, places, food, transport,
 * etc. Order roughly groups related icons together so they read well
 * in the flex-wrap grid.
 */
export const CATEGORY_ICON_CHOICES: IconName[] = [
  // Generelt / admin
  "tag",
  "sparkles",
  "calendar",
  "receipt",
  "file-text",
  "arrow-right-left",
  // Penger / økonomi
  "wallet",
  "circle-dollar",
  "credit-card",
  "banknote",
  "piggy-bank",
  "landmark",
  "trending-up",
  "pie-chart",
  // Handel / gaver
  "shopping-cart",
  "shopping-bag",
  "gift",
  // Hjem / oppussing
  "home",
  "bed",
  "sofa",
  "bath",
  "lamp",
  "lightbulb",
  "zap",
  "flame",
  "droplet",
  "tree",
  "hammer",
  "wrench",
  // Mat & drikke
  "utensils",
  "pizza",
  "coffee",
  "wine",
  "beer",
  "cake",
  "ice-cream",
  // Transport
  "car",
  "bus",
  "train",
  "bike",
  "fuel",
  "ship",
  "plane",
  // Reise / friluft
  "luggage",
  "tent",
  "mountain",
  "map-pin",
  "compass",
  "palm-tree",
  "umbrella",
  // Tech & underholdning
  "smartphone",
  "laptop",
  "headphones",
  "music",
  "film",
  "tv",
  "camera",
  "gamepad",
  "wifi",
  // Familie / kjæledyr
  "heart",
  "baby",
  "dog",
  "cat",
  // Helse / pleie
  "pill",
  "heart-pulse",
  "stethoscope",
  "scissors",
  "shirt",
  // Hobby / fritid
  "book",
  "dumbbell",
  "trophy",
  "ticket",
  // Jobb / utdanning
  "briefcase",
  "building",
  "graduation-cap",
  "backpack",
];

/**
 * Palette for the CategoryFormDialog colour picker. Tailwind-500 stops
 * pulled from across the spectrum so every choice has roughly the same
 * perceived weight against the surface background.
 */
export const CATEGORY_COLOR_CHOICES = [
  // Grønne / naturlige
  "#10b981", // emerald-500
  "#22c55e", // green-500
  "#84cc16", // lime-500
  "#14b8a6", // teal-500
  // Blå
  "#06b6d4", // cyan-500
  "#0ea5e9", // sky-500
  "#3b82f6", // blue-500
  "#6366f1", // indigo-500
  // Lilla / rosa
  "#8b5cf6", // violet-500
  "#a855f7", // purple-500
  "#d946ef", // fuchsia-500
  "#ec4899", // pink-500
  "#f43f5e", // rose-500
  // Varme
  "#ef4444", // red-500
  "#f97316", // orange-500
  "#f59e0b", // amber-500
  "#eab308", // yellow-500
  // Nøytrale
  "#78716c", // stone-500
  "#71717a", // zinc-500
  "#64748b", // slate-500
];
